<template>
  <div class="share page bg">
    <!-- 报告 -->
    <div class="report" :class="{reportOther: isOtherPage}">
      <canvas id="canvas" width="640" height="600"></canvas>
      <div class="report-texts">
        <div v-for="(item, index) in data" :class="'report-text' + index">
          <div class="report-title">{{item.title}}</div>
          <div class="report-content">{{item.content}}</div>
        </div>
      </div>
    </div>

    <!-- 打开自己的页面 -->
    <div v-if="isMyPage" class="mypage page">
      <img class="btn-back" src="../assets/p6/back.png" alt="返回按钮" @click="routeToHome" />

      <!-- 助力进度条 -->
      <div class="like-progress" :style="{width: (14.8 * overNum / 100) + 'rem'}"></div>

      <!-- 正文部分 -->
      <!-- 有抽奖 -->
      <div v-if="hasPrizeVersion" class="mypage-content">
        <div class="like-numbers">你的助力数已超过{{overNum}}%的人</div>

        <div class="btns-area">
          <div class="btn-subbmit" @click="showForms">
            <img src="../assets/p6/btn-info.png" alt="提交信息赢好礼" />
          </div>
          <div class="btn-invite" @click="showShare">
            <img src="../assets/p6/btn-invite.png" alt="邀请好友助力" />
          </div>
        </div>

        <div class="tip">邀请好友助力越多，越可能获奖哦！快告诉朋友吧～</div>
      </div>
      <!-- 无抽奖 -->
      <div v-else class="mypage-content">
        <div class="like-numbers">你的两会传播指数已超过{{overNum}}%的人</div>

        <div class="btns-area">
          <div class="btn-share" @click="showShare">
            <img src="../assets/p6/share.png" alt="分享报告" />
          </div>
          <div class="btn-retry" @click="retry">
            <img src="../assets/p6/retry.png" alt="重新扫描" />
          </div>
        </div>

        <div class="tip">分享给更多好友，看看你的两会传播指数有多高！</div>
      </div>

      <!-- 填写地址信息等 -->
      <transition name="fade">
        <div v-if="isFormsShow" class="forms">
          <div class="form-close" @click="closeForms">
            <img src="../assets/p7/close.png" alt="" />
          </div>

          <div class="form-title">
            <img src="../assets/p7/title.png" alt="" />
          </div>

          <form class="form-content">
            <input class="form-name" name="name" type="text" v-model="name" />
            <input class="form-phone" name="phone" type="text" v-model="phone" />
            <textarea class="form-address" name="address" id="" rows="3" v-model="address"></textarea>
          </form>

          <div class="form-tip">请保持手机畅通，以免错过好礼哦～</div>

          <div class="form-submit">
            <img src="../assets/p7/submit.png" alt="" @click="submit" />
          </div>
        </div>
      </transition>

      <!-- 引导分享 -->
      <transition name="fade">
        <div v-if="isShowShare" class="lead-to-share" @click="showShare">
          <img v-if="hasPrizeVersion" src="../assets/p5/share-hasprize.png" alt="" />
          <img v-else src="../assets/p5/share-noprize.png" alt="" />
        </div>
      </transition>
    </div>

    <!-- 打开别人的页面 -->
    <div v-if="isOtherPage" class="otherpage page">
      <div class="othercontent"></div>
      <div class="wxnickname">{{wxInfo.nickname}}</div>
      <div class="wxheadimage-box">
        <img class="wxheadimage" :src="wxInfo.avatar" />
      </div>

      <!-- 点赞按钮，只能给别人点 -->
      <div class="btns-area">

        <div v-if="hasPrizeVersion" class="help">
          <img v-show="!isHelpSuccess" src="../assets/p9/help-him.png" alt="" @click="like" />
          <img v-show="isHelpSuccess" :class="{'help-success': isHelpSuccess && !isHelpSuccessAlready}" src="../assets/p9/help-success.png" alt="" />
          <div class="help-tip">帮好友赢取两会纪念封</div>
        </div>
        <div v-else class="help">
          <img v-show="!isHelpSuccess" src="../assets/p9/help.png" alt="" @click="like" />
          <img v-show="isHelpSuccess" :class="{'help-success': isHelpSuccess && !isHelpSuccessAlready}" src="../assets/p9/help-done.png" alt="" />
          <div class="help-tip">点赞政府工作报告！</div>
        </div>
        
        <div class="mytry" @click="routeToHome">
          <img src="../assets/p9/let-me-try.png" alt="" />
        </div>
      </div>
    </div>

    <img v-if="showArrow" class="down-arrow" src="../assets/down-arrow.png" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import queryString from 'query-string'
import drawRadar from '../../lib/drawRadarShare'
// import { updateShare } from '../../lib/wxShare'

export default {
  name: 'share',
  data: function () {
    return {
      data: [],

      // 是否有抽奖的版本
      hasPrizeVersion: this.$store.state.hasPrizeVersion,

      // 是否显示分享页
      isShowShare: false,

      // 是否显示登记地址的页面
      isFormsShow: false,

      // 打开自己的页面
      isMyPage: false,

      // 打开别人的页面
      isOtherPage: false,
      // 是别人的数据的话，储存别人的信息
      wxInfo: {},

      // 助力数已经超过的人数，是个百分制数字
      overNum: 45,

      // 是否助力成功
      isHelpSuccess: false,
      // 是否早已助力
      isHelpSuccessAlready: false,

      // 分享id，用来为TA助力
      shareId: '',

      // 地址信息
      name: '',
      phone: '',
      address: '',

      showArrow: false
    }
  },
  mounted () {
    // 页面渲染完成，检查是否有shareId
    const self = this
    const search = queryString.parse(location.search)
    this.shareId = this.$store.state.shareId || search.shareId || 'null'
    
    console.log('share mounted')

    if (this.shareId === 'null') {
      this.$router.replace('/')
      return
    }

    // 如果页面太短，添加箭头
    if(document.body.offsetHeight / document.body.offsetWidth < 1.6) {
      this.showArrow = true

      const scrollHandler = function(){
        // console.log(1)
        self.showArrow = false
        document.removeEventListener('scroll', scrollHandler)
      }

      document.addEventListener('scroll', scrollHandler)
    }

    axios.post(this.$store.state.hostname + '/scanuser/find', {
      shareId: this.shareId
    })
      .then(response => {
        if (response.data.code !== 0 || !response.data.list || response.data.list.length === 0) {
          // 数据查询失败，打开首页

          this.routeToHome()
        } else {
          // 有数据了，看看是否是微信环境，是否有微信id，有微信id，就要看看是不是自己的了
          // console.log(response.data.list[0].wxId)
          // console.log(this.$store.state.wxUser.openid)
          // console.log(this.$store.state.wxUser.openid === response.data.list[0].wxId)
          
          if (response.data.list[0].wxId && this.$store.state.wxUser.openid && this.$store.state.wxUser.openid === response.data.list[0].wxId) {
            // 是自己的数据
            // console.log('是自己的数据')
            this.isMyPage = true

            // console.log(response.data)
            this.data = response.data.list[0].result

            this.drawPoster();

            // 计算超过人数的百分比
            this.overNum = this.generateOvernum(response.data.list[0].likeList.length)
          } else {
            // 是别人的数据
            // console.log('是别人的数据')

            this.isOtherPage = true

            this.data = response.data.list[0].result
            this.wxInfo.avatar = response.data.list[0].avatar
            this.wxInfo.nickname = response.data.list[0].nickname
            this.wxInfo.wxId = response.data.list[0].wxId

            this.drawPoster();

            // 检查助力的人里有没有这个用户
            response.data.list[0].likeList.forEach(item => {
              if(item.wxId === this.$store.state.wxUser.openid){
                this.isHelpSuccess = true
                this.isHelpSuccessAlready = true
              }
            })
            // this.drawHeadImage();
          }

          // 页面渲染完成
          this.$store.commit('setPageReady')
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    // 我的页面
    // 显示提交信息
    showForms () {
      this.isFormsShow = true
    },
    // 关闭表单
    closeForms () {
      this.isFormsShow = false
    },

    // 显示分享页
    showShare () {
      this.isShowShare = !this.isShowShare
    },

    // 提交信息，赢取好礼
    submit () {
      // 提交到数据库
      // 如果重复提交，就覆盖之前的信息
      const name = this.name
      const phone = this.phone
      const address = this.address

      // 不能为空
      if(name === '' || phone === '' || address === ''){
        alert('请完整填写所有表格内容！')
        return null
      }

      axios.post(this.$store.state.hostname + '/scanuser/address', {
        shareId: this.shareId,
        name: name,
        phone: phone,
        address: address
      })
        .then(response => {
          if(response.status === 200 && response.data.code === 0){
            console.log('提交成功')
            this.isFormsShow = false
          }else{
            alert('提交失败，请重试')
            console.log(response)
          }
        })
        .catch(err => {
          console.log(err)
          alert('提交失败，请重试')
        })
    },

    // 计算超过人数的百分比
    generateOvernum (num) {
      if(num <= 0 || typeof num !== 'number'){
        // 默认是45
        return 45
      }
      switch (num) {
        case 0: return 45
        case 1: return 50
        case 2: return 55
        case 3: return 60
        case 4: return 65
        case 5: return 70
        case 6: return 75
        case 7: return 80
        case 8: return 85
        case 9: return 90
        case 10: return 95
      }
      if(num > 10){
        return 99
      }
    },

    // 绘制海报
    drawPoster () {
      const canvas = document.getElementById('canvas')

      // 绘制雷达图
      const data = [0,0,0]
      // 识别结果的数据，组装一下
      data[0] = [this.data[0].title, this.data[0].value]
      data[1] = [this.data[1].title, this.data[1].value]
      data[2] = [this.data[2].title, this.data[2].value]
      // data[0] = ['“六稳”“六保”', this.data[0].value]
      // data[1] = ['“六稳”“六保”', this.data[1].value]
      // data[2] = ['“六稳”“六保”', this.data[2].value]


      drawRadar(canvas, data, {
        isMyPage: this.isMyPage
      })
    },

    // 别人的页面
    // 给他点赞
    like () {
      console.log('为他助力')
      
      // 当前授权的用户
      const user = this.$store.state.wxUser
      // console.log(user.nickname, user.openid, user.headimgurl)

      axios.post(this.$store.state.hostname + '/scanuser/like', {
        shareId: this.shareId,
        nickname: user.nickname,
        wxId: user.openid,
        avatar: user.headimgurl
      })
        .then(response => {
          // console.log(response)
          if(response.status === 200 && response.data.code === 0){
            // 点赞成功
            this.isHelpSuccess = true

            const player = document.getElementById('mp3-help')
            player.currentTime = 0
            player.play()

            setTimeout(() => {
              player.pause()
            }, 1000)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 我也要测
    routeToHome () {
      // 返回首页
      // history.replaceState(history.state, '', location.pathname + '#/share')
      // let url = window.location.href
      // window.location.href = url
      const player = document.getElementById('mp3-home')
      player.currentTime = 0
      player.play()

      this.$store.commit('clearShareId')
      this.$router.replace('/')
    },

    retry () {
      // 如果重新扫一扫的话，要清空input的值，不然重复上传一张图片会没有反应
      // console.log('重新扫描')
      const player = document.getElementById('mp3-text')
      player.currentTime = 0
      player.play()

      this.$store.commit('clearShareId')
      this.$router.replace('upload')
    }
  },
}
</script>

<style scoped>
  .share{
    position: relative;
    background-size: 100% auto;
    background-image: url(../assets/p6/bg.jpg);
    background-repeat: no-repeat;
    background-position: 50% 0%;
  }

  /* 我的数据页面 */
  .mypage{
    position: relative;
  }

  /* 返回按钮 */
  .btn-back{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 7;
    padding: .31rem .8rem .8rem .31rem;
    width: 1.31rem;
    height: 1.31rem;
    vertical-align: top;
  }

  /* 助力进度 */
  .like-progress{
    position: absolute;
    left: 2.84rem;
    top: 26.03rem;
    z-index: 4;

    height: 1.5rem;
    width: 0;
    /* width: 14.8rem; */
    background-color: #b24a4a;
  }

  /* 内容区域 */
  .mypage-content{
    position: relative;
    z-index: 5;
    margin-top: 1.25rem;
    width: 100%;
    height: 32.2rem;
    background-size: 100% auto;
    background-image: url(../assets/p6/content.png);
    background-repeat: no-repeat;
    background-position: 50% 0;
  }

  /* 助力人数 */
  .like-numbers{
    position: absolute;
    top: 24.9rem;
    left: 3.4rem;
    font-size: 13px;
    font-weight: bolder;
    text-shadow: 0 2px 16px #b24a4a;
    color: #ffffff;
  }
  /* 按钮区域 */
  .btns-area{
    display: -webkit-flex;
    display: flex;
    justify-content: center;

    position: absolute;
    top: 27rem;
    left: 0;
    width: 20rem;
    text-align: center;
    font-size: 0;
    vertical-align: top;
  }
  .mypage .btns-area{
    justify-content: center;
    margin: 0 2.81rem 0 2.31rem;
    width: 14.88rem;
  }

  .btn-subbmit img{
    width: 6.75rem;
    height: 1.875rem;
  }
  /* 邀请好友 */
  .btn-invite img{
    margin-left: 1.875rem;
    width: 5.9375rem;
    height: 1.875rem;
  }
  /* 分享报告 */
  .btn-share img{
    width: 4.5rem;
    height: 1.875rem;
  }
  .btn-retry img{
    margin-left: 1.875rem;
    width: 4.5rem;
    height: 1.875rem;
  }
  /* 提示文字 */
  .tip{
    position: absolute;
    top: 29rem;

    width: 100%;
    text-align: center;

    font-size: 10px;
    color: #856988;
  }

  /* 分享提示 */
  .lead-to-share{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 19;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    font-size: 1.5rem;
    color: #ffffff;
  }
  .lead-to-share img{
    position: absolute;
    top: .75rem;
    left: .75rem;
    width: 18.03rem;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  /* 表单部分 */
  .forms{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;

    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
  }
  .form-close{
    position: absolute;
    top: 0;
    right: 0;
    padding: .94rem .82rem;
  }
  .form-close img{
    width: 1.5rem;
    vertical-align: top;
  }

  .form-title{
    margin-top: 3.6rem;
  }
  .form-title img{
    width: 7.62rem;
    vertical-align: top;
  }

  /* 表格正文区域 */
  .form-content{
    position: relative;
    margin-top: 1.2rem;
    width: 100%;
    height: 9.2rem;
    background-size: 100% 100%;
    background-image: url(../assets/p7/content.png);
    background-repeat: no-repeat;
    background-position: 50% 0%;
  }
  .form-name{
    position: absolute;
    top: .5rem;
    left: 6.4rem;

    border: 0;
    width: 11rem;
    height: 2rem;
    /* background-color: #856988; */
  }
  .form-phone{
    position: absolute;
    top: 3.3rem;
    left: 6.4rem;

    border: 0;
    width: 11rem;
    height: 2rem;
    /* background-color: #ffffff; */
  }
  .form-name, .form-phone, .form-address{
    background-color: rgba(0, 0, 0, 0);
    line-height: 2rem;
    font-size: 1rem;
    color: #ffffff;
    outline: none;
  }
  .form-address{
    position: absolute;
    top: 5.9rem;
    left: 6.4rem;

    border: 0;
    width: 11rem;
    height: 2.6rem;
    /* background-color: #856988; */
    line-height: 1.2;
    font-size: .8rem;
    resize: none;
  }
  
  /* 表格底下的提示文字 */
  .form-tip{
    margin-top: .6rem;
    text-align: center;
    line-height: 1;
    font-size: 10px;
    color: #ffffff;
  }
  
  /* 表格提交按钮 */
  .form-submit{
    margin-top: 1.5rem;
    font-size: 0;
  }
  .form-submit img{
    width: 5.5rem;
    vertical-align: center;
  }

  /* 报告部分 */
  .report{
    position: absolute;
    top: 6.6rem;
    z-index: 6;
    font-size: 0;
  }
  #canvas{
    position: relative;
    top: .2rem;
    width: 20rem;
  }
  .reportOther #canvas{
    top: -.4rem;
  }
  .report-texts{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    
    text-align: left;
  }
  .report-text0{
    position: absolute;
    top: .18rem;
    left: 1.52rem;

    width: 17.1rem;
    height: 4.6rem;
  }
  .report-text1{
    position: absolute;
    top: 4.93rem;
    left: 1.52rem;

    width: 6.5rem;
    height: 9rem;
  }
  .report-text2{
    position: absolute;
    top: 14.1rem;
    left: 1.52rem;

    width: 17.1rem;
    height: 4.6rem;
  }
  .report-title{
    margin: 6px 5px 3.5px; 
    line-height: 1;
    font-family: title_l2;
    font-size: .82rem;
    color: #aab9d7;
  }
  .report-content{
    margin: 3.5px 5px;
    line-height: .75rem;
    font-size: .5625rem;
    color: #aab9d7;
  }

  .reportOther{
    top: 7.2rem;
  }
  .reportOther .report-text0{
    top: .32rem;
    left: 1.45rem;

    width: 16.7rem;
    height: 4.5rem;
  }
  .reportOther .report-text1{
    top: 4.93rem;
    left: 1.45rem;

    width: 6.34rem;
    height: 8.8rem;
    
  }
  .reportOther .report-text2{
    top: 13.88rem;
    left: 1.45rem;

    width: 16.7rem;
    height: 4.46rem;
    /* background-color: rgba(214, 180, 150, 0.7); */
  }


  /* 别人的数据页面 */
  .otherpage{
    position: relative;
  }

  .othercontent{
    position: absolute;
    top: .94rem;
    left: 0;
    width: 20rem;
    height: 25.6rem;
    background-size: 19.47rem auto;
    background-image: url(../assets/p9/content.png);
    background-repeat: no-repeat;
    background-position: 0 0;
  }

  .otherpage .btns-area{
    /* display: flex */
    position: absolute;
    top: 26.6rem;
    left: 4.44rem;
    width: 10.4rem;
    font-size: 0;
  }
  .btns-area .help{
    position: relative;
    width: 3.75rem;
    height: 3.75rem;
  }
  .help-tip{
    position: absolute;
    left: 50%;
    bottom: -14px;

    margin-left: -60px;
    width: 120px;
    text-align: center;
    line-height: 1;
    font-size: 9px;
    color: #b8b5b9;
  }
  .btns-area .help img{
    width: 3.75rem;
  }

  .btns-area .mytry img{
    width: 3.75rem;
    margin-left: 4rem;
  }

  .wxnickname{
    position: absolute;
    top: 1.6rem;
    left: 4.2rem;
    font-family: 'title_l';
    font-size: .72rem;
    color: #1e3452;
  }
  .wxheadimage-box{
    position: absolute;
    top: 0.44rem;
    left: 1.6rem;
    width: 2.375rem;
    height: 2.34rem;
    background-image: url(../assets/p9/head-image-box.png);
    background-size: 100% 100%;
    font-size: 0;
  }
  .wxheadimage{
    position: relative;
    top: 0.08rem;
    left: 0;
    width: 2.125rem;
    height: 2.1rem;
    border-radius: 6px;
    background-color: #ffffff;
    vertical-align: top;
  }

  .help-success{
    position: relative;
    z-index: 2;
    -webkit-animation: hs .5s ease;
    animation: hs .5s ease;
  }
  @-webkit-keyframes hs {
    0% { -webkit-transform: scale3d(1,1,1)}
    50% { -webkit-transform: scale3d(1.5,1.5,1)}
    100% { -webkit-transform: scale3d(1,1,1)}
  }
  @keyframes hs {
    0% { transform: scale3d(1,1,1)}
    50% { transform: scale3d(1.5,1.5,1)}
    100% { transform: scale3d(1,1,1)}
  }
  
  .down-arrow{
    position: fixed;
    bottom: 2rem;
    left: 9rem;
    z-index: 5;
    width: 2rem;
    -webkit-animation: fadeUpOut 1s ease;
    animation: fadeUpOut 1s ease;

  }
  @-webkit-keyframes fadeUpOut {
    0% {opacity: 1;}
    25% {opacity: 0;}
    50% {opacity: 1;}
    75% {opacity: 0;}
    100% {opacity: 1;}
  }
  @keyframes fadeUpOut {
    0% {opacity: 1;}
    25% {opacity: 0;}
    50% {opacity: 1;}
    75% {opacity: 0;}
    100% {opacity: 1;}
  }
</style>
